<template>
  <el-dialog title="通道列表" :visible="visible" width="720px" @update:visible="updateVisible">
    <el-table :data="channelList" stripe border>
      <el-table-column label="通道名称" align="center" min-width="200">
        <template slot-scope="{ row }">
          {{ row.up_channel_name }}
        </template>
      </el-table-column>
      <el-table-column label="通道编码" align="center" min-width="160">
        <template slot-scope="{ row }">
          {{ row.up_code }}
        </template>
      </el-table-column>
      <el-table-column label="通道状态" align="center">
        <template slot-scope="{ row }">
          <el-tag :type="row.isopen == 1 ? 'success' : 'warning'" disable-transitions>
            {{ row.isopen == 1 ? '开启' : '关闭' }}
          </el-tag>
        </template>
      </el-table-column>
    </el-table>
    <div slot="footer">
      <el-button @click="updateVisible(false)">关闭</el-button>
    </div>
  </el-dialog>
</template>

<script>
export default {
  name: 'roundEdit',
  props: {
    visible: Boolean,
    data: Object,
  },
  data() {
    return {
      form: Object.assign({}, this.data),
      isUpdate: false,
      channelList: [],
    };
  },
  watch: {
    data() {
      if (this.data) {
        this.form = Object.assign({}, this.data);
        this.queryChannelList();
        this.isUpdate = true;
      } else {
        this.form = {};
        this.channelList = [];
        this.isUpdate = false;
      }
    },
  },
  methods: {
    queryChannelList() {
      this.$http
        .post('/Uplist/getChannelList', {
          uplist_id: this.form.id,
        })
        .then((res) => {
          if (res.data.code === 0) {
            this.channelList = res.data.data;
          } else {
            this.$message.error(res.data.msg);
          }
        })
        .catch((e) => {
          this.$message.error(e.message);
        });
    },
    updateVisible(value) {
      this.$emit('update:visible', value);
    },
  },
};
</script>

<style scoped></style>
